import init from "../components/_accordions";
init();